<template>
  <!-- .mc my-center -->
  <div class="mc">
    <div class="mc-top">
      <div class="mt-left">
        <div class="mt-imgbox" :class="userInfo.inMember.userRole === 'EXHIBITOR' ? 'role' : ''">
          <img v-if="userInfo.avatarUrl" :src="userInfo.avatarUrl" />
          <span class="flag-icon" v-else-if="userInfo.flagStyle" :class="'flag-icon-' + userInfo.flagStyle"></span>
          <img v-else src="@/assets/img/avatar.png" />
          <div class="mt-role" v-if="userInfo.inMember.userRole === 'EXHIBITOR'">
            <span v-if="userInfo.inMember.userRole === 'EXHIBITOR'">Exhibitior</span>
          </div>
        </div>
        <div class="mt-set">
          <van-button class="mt-edit" @click="LinkExInvitation({ exhibitorId: userInfo.inMember.exhibitorId, inMemberId: userInfo.inMember.id })" v-if="userInfo.inMember.userRole === 'EXHIBITOR'">My Company</van-button>
          <van-button class="mt-edit" v-else @click="goToPersonal">Modify</van-button>
        </div>
      </div>
      <div class="mt-info">
        <div class="mti-title">
          <template v-if="userInfo.inMember.userRole === 'EXHIBITOR'">
            {{ userInfo.inMember.companyUsers.linkNameEn }}
            <span>{{ userInfo.jobTitleEn || "" }}</span>
          </template>
          <template v-else>
            {{ userInfo.name || userInfo.nickName || "" }}
            <span v-if="this.userInfo.email">{{ userInfo.jobTitle || "" }}</span>
          </template>
        </div>
        <div class="mti-p" v-if="userInfo.inMember.userRole === 'EXHIBITOR'">
          {{ userInfo.inMember.companyUsers&&userInfo.inMember.companyUsers.company.nameEn?userInfo.inMember.companyUsers.company.nameEn:'' }}
        </div>
        <div class="mti-p" v-else-if="this.userInfo.email">
          {{ userInfo.company }}
        </div>
        <div class="mti-brand" v-if="this.userInfo.email">
          <template v-for="(brand, index) in getCateList(userInfo.inMember.category)">
            <span :key="'brand-' + index">{{ brand }}</span>
          </template>
        </div>
        <div v-if="this.userInfo.email" class="mti-content van-multi-ellipsis--l3">
          {{ userInfo.introduction || "" }}
        </div>
      </div>
    </div>

    <div class="mc-card3">
      <van-cell is-link @click="goToTalks">
        <template #icon>
          <div class="m-brand">
            <div class="icon-wrap s-1">
              <i class="icon iconfont icon-gerenxinxi"></i>
              <div class="hot" :class="{ max: talkMsgCount > 99 }" v-if="talkMsgCount > 0">{{ talkMsgCount > 99 ? "99+" : talkMsgCount }}</div>
            </div>
          </div>
        </template>
        <template #title>Contact records</template>
      </van-cell>
      <!-- <van-cell is-link @click="judgeGoto('LinkToMyContacts')">
        <template #icon>
          <div class="m-brand">
            <div class="icon-wrap s-2">
              <i class="icon iconfont icon-zaixianjiaotan"></i>
            </div>
          </div>
        </template>
        <template #title>我的人脉</template>
      </van-cell> -->
      <van-cell is-link @click="judgeGoto('LinkToMyOrder', true)">
        <template #icon>
          <div class="m-brand">
            <div class="icon-wrap s-3">
              <i class="icon iconfont icon-yuyue"></i>
            </div>
          </div>
        </template>
        <template #title>Business</template>
      </van-cell>
      <van-cell is-link @click="goBusiness" v-if="enabledSupplyDemand">
        <template #icon>
          <div class="m-brand">
            <div class="icon-wrap s-7">
              <i class="icon iconfont icon-jiaoyi1"></i>
            </div>
          </div>
        </template>
        <template #title>Supply & Demand</template>
      </van-cell>
      <van-cell is-link @click="LinkToMyCollect">
        <template #icon>
          <div class="m-brand">
            <div class="icon-wrap s-4">
              <i class="icon iconfont icon-wujiaoxingxingxing"></i>
            </div>
          </div>
        </template>
        <template #title>Following</template>
      </van-cell>
      <van-cell is-link @click="judgeGoto('LinkToMyInquiry', true)">
        <template #icon>
          <div class="m-brand">
            <div class="icon-wrap s-8">
              <i class="icon iconfont icon-xunpan"></i>
            </div>
          </div>
        </template>
        <template #title>Inquiry records</template>
      </van-cell>
    </div>

    <div class="mc-card3">
      <!-- <van-cell is-link @click="LinkToMyOrder">
        <template #icon>
          <div class="m-brand">
            <div class="icon-wrap s-2">
              <i class="icon iconfont icon-luntannor"></i>
            </div>
          </div>
        </template>
        <template #title>预约洽谈</template>
      </van-cell> -->
      <!-- <van-cell is-link @click="LinkToMyLive">
        <template #icon>
          <div class="m-brand">
            <div class="icon-wrap s-3">
              <i
                class="icon iconfont icon-zhibobofangshexiangjiguankanxianxing"
              ></i>
            </div>
          </div>
        </template>
        <template #title>直播</template>
      </van-cell> -->
      <!-- <van-cell is-link @click="LinkToMyActivity">
        <template #icon>
          <div class="m-brand">
            <div class="icon-wrap s-3">
              <i class="icon iconfont icon-flag-2"></i>
            </div>
          </div>
        </template>
        <template #title>活动</template>
      </van-cell> -->
      <van-cell is-link @click="LinkToMyMessage">
        <template #icon>
          <div class="m-brand">
            <div class="icon-wrap s-2">
              <i class="icon iconfont icon-mail"></i>
              <div class="hot" v-if="isHasUnReadMsg">new</div>
            </div>
          </div>
        </template>
        <template #title>Notification</template>
      </van-cell>
      <!-- <van-cell is-link @click="LinkToMyTrack">
        <template #icon>
          <div class="m-brand">
            <div class="icon-wrap s-3">
              <i class="icon iconfont icon-zuji"></i>
            </div>
          </div>
        </template>
        <template #title>足迹</template>
      </van-cell> -->
      <!-- <van-cell is-link @click="judgeGoto('LinkToMyTopic')">
        <template #icon>
          <div class="m-brand">
            <div class="icon-wrap s-3">
              <i class="icon iconfont icon-huati"></i>
            </div>
          </div>
        </template>
        <template #title>话题</template>
      </van-cell> -->
      <van-cell is-link @click="LinkToMyService">
        <template #icon>
          <div class="m-brand">
            <div class="icon-wrap s-6">
              <i class="icon iconfont icon-kefu"></i>
            </div>
          </div>
        </template>
        <template #title>Contact Organzier</template>
      </van-cell>
      <!-- <van-cell is-link @click="LinkToMyFeedback">
        <template #icon>
          <div class="m-brand">
            <div class="icon-wrap s-5">
              <i class="icon iconfont icon-pingjia"></i>
            </div>
          </div>
        </template>
        <template #title>Feedback</template>
      </van-cell> -->
    </div>

    <!-- <div class="mc-login" @click="LinkToExLogin(exhibitionId)">
      <div class="mcl-l">
        <i class="icon iconfont icon-iconfontwodea"></i>展商登录
      </div>
      <div class="mcl-r">
        <span>参展企业在此登录</span><i class="iconfont icon-xiala"></i>
      </div>
    </div> -->
    <div class="mc-like">
      <div class="mc-like-title">
        <img src="@assets/img/new/icon-line-l.png" />
        <span>You might also like</span>
        <img src="@assets/img/new/icon-line-r.png" />
      </div>
      <!-- <div class="mc-like-title">
        <img src="@assets/img/new/icon-line-l.png" />
        <span>猜您喜欢</span>
        <img src="@assets/img/new/icon-line-r.png" />
      </div> -->
      <exTabList v-if="isOk"></exTabList>
    </div>
    <layoutFooter></layoutFooter>
  </div>
</template>

<script>
import layoutFooter from "@components/layout-footer";
import gql from "graphql-tag";
import exTabList from "./components/ex-tab-list";
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
export default {
  name: "my-center",
  data () {
    return {
      activeName: "product",
      isHasUnReadMsg: false,
      sayHelloUnreadCount: 0,
      hasUnreadMessage: {},
      sayHelloUnreadNumber: {},
      isOk: false,
    };
  },
  components: {
    exTabList,
    layoutFooter,
  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo", // 用户身份类别 0：游客、1：普通买家、2：专业买家、3：行业名人、4：展商
      userRole: "getUserRole",
      exhibitionId: "getExhibitionId",
      exhibitionInfo: "getExhibitionInfo",
      talkMsgCount: "getTalkMsgCount",
    }),
    ...mapState({
      oMyPro: "oMyPro",
      oMyBus: "oMyBus",
      oLogo: "oLogo",
      oPotoView: "oPotoView",
    }),
    isServer () {
      let ser = false;
      if (this.userInfo && this.userInfo.inMember && this.userInfo.inMember.companyUsers && this.userInfo.inMember.companyUsers.isAppointment) {
        ser = true;
      }
      return ser;
    },
    userMsgQuery () {
      return `
        query{
          agoraQuery{
            userUnreadNumber(exhibitionId:"${this.exhibitionId}",publisherId:"${this.userInfo.userId}")
          }
        }
      `;
    },
    serviceMsgQuery () {
      return `
        query{
          agoraQuery{
            exhibitorUnreadNumber(exhibitorId:"${this.userInfo.inMember.exhibitorId}",publisherId:"${this.userInfo.inMember.companyUsers.id}")
          }
        }
      `;
    },
    isBlack () {
      return this.userInfo && this.userInfo.inMember.isBlacklist;
    },
    enabledSupplyDemand () {
      return this.exhibitionConfig && this.exhibitionConfig.feature && this.exhibitionConfig.feature.enabledSupplyDemand;
    },
  },
  async created () {
    this.$store.commit("setExhibitionId", this.$route.params.id);
    // console.log(this.exhibitionId,'idid')
    await this.$Myapollo.getUserInfo(this);
    await this.$Myapollo.getExhibitionInfo(this, this.$route.params.id, this.userInfo.userId);
    console.log(this.userInfo);
    this.$Myapollo.addExhibitionView();
    this.isOk = true;
    this.getMsgState();
    this.getSayHelloUnreadCount();
    this.getCount();
    // this.wxHideAllMenu(); // 隐藏微信分享菜单
  },
  methods: {
    ...mapActions({
      LinkToMyOrder: "linkTo/LinkToMyOrder", //预约洽谈
      LinkToMyTalks: "linkTo/LinkToMyTalks", //我的-洽谈记录
      LinkToMyTalksUser: "linkTo/LinkToMyTalksUser", //我的-洽谈记录-用户
      LinkToMyPapers: "linkTo/LinkToMyPapers", //我的证件
      LinkToMyContacts: "linkTo/LinkToMyContacts", //我的人脉
      LinkToMyBusiness: "linkTo/LinkToMyBusiness", //我的供需
      LinkToMyTopic: "linkTo/LinkToMyTopic", //我的话题
      LinkToMyCollect: "linkTo/LinkToMyCollect", //我的关注
      LinkToMyActivity: "linkTo/LinkToMyActivity", //我的活动
      LinkToMyLive: "linkTo/LinkToMyLive", //我的直播
      LinkToMyTrack: "linkTo/LinkToMyTrack", //我的足迹
      LinkToMyMessage: "linkTo/LinkToMyMessage", //我的消息
      LinkToMyFeedback: "linkTo/LinkToMyFeedback", //我的反馈
      LinkToMyService: "linkTo/LinkToMyService", //我的客服
      LinkToMyAccount: "linkTo/LinkToMyAccount", //我的账户
      LinkToReg: "linkTo/LinkToReg", // 注册页面
      LinkToRegUser: "linkTo/LinkToRegUser",
      LinkToEditUser: "linkTo/LinkToEditUser", // 编辑个人资料
      wxHideAllMenu: "wxShare/wxHideAllMenu",
      LinkToExLogin: "linkTo/LinkToExLogin", // 展商登录
      LinkToMyInquiry: "linkTo/LinkToMyInquiry",
      LinkExInvitation: "linkTo/LinkExInvitation",
      graphqlPost: "en/CNgraphqlPostByZXS",
    }),
    ...mapMutations({
      setTalkMsgCount: "setTalkMsgCount",
    }),
    goBusiness () {
      if (this.isBlack) {
        this.$toast.fail("You do not have access");
        return;
      }
      this.LinkToMyBusiness();
    },
    goToTalks () {
      // if(!this.userInfo.id){
      //   this.$Myapollo.NoUserInfo(this);
      //   return
      // }
      if (this.isBlack) {
        this.$toast.fail("You do not have access");
        return;
      }
      if (this.isServer) {
        this.LinkToMyTalks();
        // this.LinkToMyTalksUser()
      } else {
        this.LinkToMyTalksUser();
      }
    },
    async getCount () {
      let opt = {
        query: this.userMsgQuery,
        variables: {},
      };
      let data = await this.graphqlPost(opt);
      let count = data.data.agoraQuery.userUnreadNumber || 0;
      if (this.isServer) {
        let opt2 = {
          query: this.serviceMsgQuery,
          variables: {},
        };
        let data2 = await this.graphqlPost(opt2);
        // console.log(data2,'data2')
        count += data2.data.agoraQuery.exhibitorUnreadNumber || 0;
      }
      console.log("新洽谈消息数量", count);
      this.setTalkMsgCount(count || 0);
    },
    wCount (value) {
      //过万处理
      let num = value;
      if (value > 9999) {
        //大于9999显示x.xx万
        num = Math.floor(value / 100) / 100 + "w";
      } else {
        num = value;
      }
      return num;
    },
    //获取未读消息数量
    getSayHelloUnreadCount () {
      // console.log(this.userInfo.inMember.id)
      let query = gql`
        query sayHelloUnreadNumber($exhibitionId: Guid!, $inMemberId: Guid!) {
          sayHelloUnreadNumber(exhibitionId: $exhibitionId, inMemberId: $inMemberId)
        }
      `;
      this.$apollo.addSmartQuery("sayHelloUnreadNumber", {
        query: query,
        variables: {
          exhibitionId: this.exhibitionId,
          inMemberId: this.userInfo.inMember.id,
        },
        fetchPolicy: "network-only", //清理缓存
        result (data) {
          let res = JSON.parse(JSON.stringify(data.data.sayHelloUnreadNumber));
          // let res=data.data.queryProduct;
          // console.log(res)
          this.sayHelloUnreadCount = res;
        },
        error (err) {
          console.log("err", err);
        },
      });
    },
    //获取是否存在未读消息
    getMsgState () {
      // console.log(this.exhibitionInfo.exhibition.host.id,'ss');
      // console.log(this.exhibitionId,'ss1');
      // console.log(this.userInfo.userId,'ss2');
      let query = gql`
        query hasUnreadMessage($hostId: Guid!, $exhibitionId: Guid!, $userId: String!) {
          hasUnreadMessage(hostId: $hostId, exhibitionId: $exhibitionId, userId: $userId)
        }
      `;
      this.$apollo.addSmartQuery("hasUnreadMessage", {
        query: query,
        variables: {
          hostId: this.exhibitionInfo.exhibition.host.id,
          exhibitionId: this.exhibitionId,
          userId: this.userInfo.userId,
        },
        fetchPolicy: "network-only", //清理缓存
        result (data) {
          // console.log(data,'消息');
          let res = JSON.parse(JSON.stringify(data.data.hasUnreadMessage));
          // let res=data.data.queryProduct;
          // console.log(res)
          this.isHasUnReadMsg = res;
        },
        error (err) {
          console.log("err", err);
        },
      });
    },
    //判断用户身份是弹框还是直接跳转
    judgeGoto (link, black = false) {
      if (!link) {
        // this.$toast("暂未开放,敬请期待");
        return;
      }
      if (black && this.isBlack) {
        this.$toast.fail("You do not have access");
        return;
      }
      if (link == "LinkToMyPapers" && this.userRole.toUpperCase() == "VISITOR") {
        this.$Myapollo.unverifiedDialog(this, true, this.exhibitionId);
      } else {
        this[`${link}`]();
      }
    },
    //点击编辑个人资料,未注册跳注册页面
    goToPersonal () {
      console.log(this.userInfo, this.userRole);
      if (this.userRole.toUpperCase() == "VISITOR" || !this.userInfo.email) {
        console.log("前去注册");
        // this.LinkToReg();
        // 去掉跳转外链
        this.LinkToRegUser();
      } else {
        //编辑个人资料页面
        console.log("已注册去编辑");
        this.LinkToEditUser();
      }
    },
    //得到供需内容
    getBuContetn (str) {
      return JSON.parse(str).content;
    },
    //得到供需图片List
    getBuImgList (str) {
      return JSON.parse(str).imgList;
    },
    //预览图片
    viewImg (imgList, index) {
      ImagePreview({ images: imgList, startPosition: index });
    },
    getCateList (str) {
      if (str) {
        let newStr = str.replace(/>/g, "/");
        let option = newStr.split(";");
        let returnArr = [];
        option.forEach((e) => {
          let arr = e.split("/");
          returnArr.push(arr[arr.length - 1]);
        });
        // console.log(returnArr,'cate')
        return returnArr;
      } else {
        return [];
      }
    },
    //获取元素高度
    getElHeight () {
      this.$nextTick(() => {
        // let h = $(".interest").height();
        // if (h > 30) {
        //   this.isbr = true;
        // }
      });
    },
    //产品加载
    proLoad () { },
    //话题加载
    topicLoad () { },
    //展商加载
    cardLoad () { },
    //个人资料修改
    editData () {
      this.$router.push("/editPersonData");
    },
    //供需修改
    editSupply () {
      this.$router.push("/editSupply");
    },
    //普通用户认证专业买家
    goToreg () {
      if (this.userInfo.auditState == 0) {
        this.$toast.fail("认证资料正在审核中，请耐心等待...");
        return;
      }
      this.$router.push("/editAuerbach");
    },
  },
};
</script>

<style lang="scss" scoped>
.mc {
  background-color: #f2f2f2;
  overflow: hidden;
  padding-bottom: 1rem;
  &-top {
    box-shadow: 0 0.05rem 0.1rem 0 rgba(153, 153, 153, 0.1);
    border-radius: 0 0 0.3rem 0.3rem;
    background-image: url(../../assets/img/new/bg-my.png);
    background-repeat: no-repeat;
    background-size: contain;
    background-color: #fff;
    padding: 0.7rem 0.3rem 0.4rem;
    .mt {
      &-left {
        display: flex;
        // margin-bottom: 0.24rem;
        align-items: center;
        justify-content: space-between;
        .mt-imgbox {
          width: 1.1rem;
          height: 1.26rem;
          margin-right: 0.19rem;
          position: relative;
          text-align: center;
          img {
            width: 1.1rem;
            height: 1.1rem;
            border-radius: 50%;
            border: 0.03rem solid #fff;
          }
          .flag-icon {
            width: 1.1rem;
            height: 1.1rem;
            border-radius: 50%;
            border: 0.03rem solid #fff;
          }
          .mt-role {
            position: absolute;
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;
            bottom: 0;
            left: 0.1rem;
            height: 0.32rem;
            border-radius: 0.03rem;
            width: 0.9rem;
            background: #f85b0f;
            color: #fffefe;
            span {
              font-size: 0.2rem;
              width: 100%;
            }
          }
        }
        .role {
          margin-bottom: 0.2rem;
        }
        .mt-set {
          width: 2.46rem;
          display: flex;
          justify-content: flex-end;
          .mt-edit {
            height: 0.56rem;
            line-height: 0;
            padding: 0 0.14rem;
            border-radius: 0.07rem;
            box-shadow: 0 0 0.1rem 0 rgba(0, 0, 0, 0.1);
            border: none;
          }
          .mt-seticon {
            border-radius: 0.07rem;
            height: 0.56rem;
            line-height: 0;
            padding: 0 0.13rem;
            margin-left: 0.1rem;
            box-shadow: 0 0 0.1rem 0 rgba(0, 0, 0, 0.1);
            border: none;
            &::v-deep .van-button__text {
              .iconfont {
                transform: scale(1.6);
              }
            }
          }
        }
      }
      &-info {
        position: relative;
        padding-top: 0.1rem;
        min-height: 0.58rem;
        // padding-bottom: 0.4rem;
        .mti {
          &-title {
            display: flex;
            align-items: flex-end;
            line-height: 1;
            font-size: 0.36rem;
            color: #333;
            margin-bottom: 0.19rem;
            font-weight: bold;
            span {
              line-height: normal;
              font-weight: normal;
              font-size: 0.24rem;
              color: #666;
              margin-left: 0.2rem;
            }
          }
          &-p {
            font-size: 0.24rem;
            color: #333;
            font-weight: bold;
          }
          &-brand {
            margin-top: 0.18rem;
            // max-width: calc(100% - 2rem);
            span {
              background-color: rgba(#f85b0f, 0.1);
              border-radius: 0.05rem;
              font-size: 0.22rem;
              color: #f85b0f;
              display: inline-block;
              margin-right: 0.1rem;
              margin-bottom: 0.18rem;
              padding: 0.06rem;
            }
          }
          &-content {
            font-size: 0.24rem;
            color: #666;
            //
          }
          &-balance {
            position: absolute;
            right: 0;
            top: 0;
            padding: 0 0.13rem;
            height: 0.58rem;
            box-sizing: border-box;
            color: #666;
            font-size: 0.22rem;
            display: flex;
            border-radius: 0.1rem;
            background: rgba(248, 91, 15, 0.1);
            align-items: center;
            img {
              width: 0.26rem;
              height: 0.26rem;
              display: block;
              margin: 0 0.1rem;
            }
            .icon-xiala {
              color: #999;
              margin-left: 0.05rem;
              font-size: 0.26rem;
              transform: rotate(-90deg);
            }
          }
        }
      }
    }
  }

  &-card3 {
    background-color: #fff;
    box-shadow: 0 0.05rem 0.1rem 0 rgba(153, 153, 153, 0.1);
    border-radius: 0.1rem;
    margin: 0.3rem 0.3rem 0 0.3rem;
    overflow: hidden;
    ::v-deep {
      .van-cell__title {
        display: flex;
        align-items: center;
      }
    }

    .m-brand {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      margin-right: 0.3rem;
      .icon-wrap {
        width: 0.6rem;
        height: 0.6rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 0.05rem;
        position: relative;
        position: relative;
        .hot {
          position: absolute;
          top: -0.15rem;
          right: -0.15rem;
          width: 0.3rem;
          height: 0.3rem;
          background-color: #f85a10;
          border-radius: 15px 15px 15px 0px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.16rem;
          color: #fff;
          &.max {
            font-size: 0.14rem;
          }
        }
        .num {
          position: absolute;
          top: -0.15rem;
          right: -0.15rem;
          width: 0.3rem;
          height: 0.3rem;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #fff;
          border: solid 0.02rem #f85b0f;
          font-size: 0.16rem;
          color: #f85b0f;
          border-radius: 50%;
        }
        .iconfont {
          font-size: 0.4rem;
          color: #fff;
        }
        &.s-1 {
          background-image: linear-gradient(45deg, #bd72ff 0%, #fd929a 100%),
            linear-gradient(#0490ff, #0490ff);
        }
        &.s-2 {
          background-image: linear-gradient(45deg, #ff5c8f 0%, #ffa7ba 100%),
            linear-gradient(#0490ff, #0490ff);
        }
        &.s-3 {
          background-image: linear-gradient(45deg, #8c94ff, #61dcfe),
            linear-gradient(#fff, #fff);
        }
        &.s-4 {
          background-image: linear-gradient(
              45deg,
              rgba(139, 113, 231, 0.98) 0%,
              rgba(185, 153, 254, 0.98) 100%
            ),
            linear-gradient(#0490ff, #0490ff);
        }
        &.s-5 {
          background-image: linear-gradient(45deg, #40afe8 0%, #3eefff 100%),
            linear-gradient(#fff, #fff);
        }
        &.s-6 {
          background-image: linear-gradient(45deg, #ff9a4e 0%, #fbca51 100%),
            linear-gradient(#fff, #fff);
        }
        &.s-7 {
          background-image: linear-gradient(45deg, #ff9466, #fe94a0),
            linear-gradient(#fff, #fff);
        }
        &.s-8 {
          background-image: linear-gradient(45deg, #1ec29d, #9bffd1),
            linear-gradient(#fff, #fff);
        }
        p {
          width: 100%;
          // font-size: 0.24rem;
          color: #333;
          text-align: center;
        }
      }
    }

    &-login {
      height: 0.98rem;
      background-color: #fff;
      box-shadow: 0 0.05rem 0.1rem 0 rgba(153, 153, 153, 0.1);
      border-radius: 0.1rem;
      margin: 0.3rem 0.3rem 0 0.3rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 0.3rem;
      .mcl {
        &-l {
          font-size: 0.24rem;
          color: #241d1d;
          display: flex;
          align-items: center;
          .iconfont {
            font-size: 0.5rem;
            display: inline-block;
            // margin-right: 0.05rem;
          }
        }
        &-r {
          font-size: 0.24rem;
          color: #999;
          display: flex;
          align-items: center;

          i {
            display: block;
            transform: rotate(-90deg);
          }
          span {
            display: inline-block;
            margin-right: 0.05rem;
          }
        }
      }
    }
    &-like {
      &-title {
        padding: 0.3rem 0.3rem 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        img {
          flex: 1;
          width: 1.82rem;
        }
        span {
          padding: 0 0.2rem;
          font-size: 0.3rem;
          color: #333;
        }
      }
    }
  }
  &-like {
    &-title {
      padding: 0.3rem 0.3rem 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      img {
        flex: 1;
        width: 1.7rem;
      }
      span {
        padding: 0 0.1rem;
        font-size: 0.3rem;
      }
    }
  }
}
</style>
